module.exports = __webpack_public_path__ + "img/logo.fcef5764.png";